var map = {
	"./OnTrac.jpeg": 635,
	"./Paecel Force.jpeg": 481,
	"./Royal Mail.jpeg": 290,
	"./Tnt.jpeg": 478,
	"./Ups.jpeg": 306,
	"./Yodel.jpeg": 109,
	"./login_front.png": 432,
	"./logo.png": 374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 467;